import React, { useEffect } from 'react';
import PolicyLayout from '../components/common/PolicyLayout/PolicyLayout';

const TermsConditions = () => {
  useEffect(() => {
    document.title = 'NEST | Terms & Conditions';
  }, []);
  return (
    <PolicyLayout title="Terms and Conditions" breadcrumbs={['Terms & Conditions']}>
      <h1>Terms and Conditions</h1>

      <h2>1. Acceptance of Terms</h2>
      <p>
        Welcome to <strong>Nest Auto Transport</strong>. These Terms and Conditions ("Terms") govern your access to
        and use of our website and services (collectively referred to as the "Services"). By using our Services, you
        agree to comply with and be bound by these Terms. If you do not agree, please discontinue using our Services.
      </p>

      <h2>2. Description of Services</h2>
      <p>
        <strong>Nest Auto Transport</strong> provides nationwide vehicle shipping services across the United States.
        We act as a professional auto transport brokerage, connecting customers with fully licensed and insured
        carriers for the safe and efficient transport of vehicles. Our services include:
      </p>
      <ul>
        <li>Open carrier transport</li>
        <li>Enclosed carrier transport</li>
        <li>Door-to-door vehicle delivery</li>
        <li>Expedited shipping</li>
        <li>Nationwide vehicle transport</li>
        <li>Shipping for cars, SUVs, trucks, motorcycles, and specialty vehicles</li>
      </ul>

      <h2>3. Broker Relationship</h2>
      <p>
        <strong>Nest Auto Transport</strong> operates as a licensed broker and does not directly transport vehicles.
        We arrange vehicle transportation through vetted, insured, and authorized auto carriers who perform the
        physical shipment of vehicles.
      </p>

      <h2>4. Quotes and Pricing</h2>
      <p>
        Pricing provided by <strong>Nest Auto Transport</strong> is based on the information shared at the time of the
        quote. Final pricing may vary due to factors such as:
      </p>
      <ul>
        <li>Vehicle size, weight, and modifications</li>
        <li>Pickup and delivery locations</li>
        <li>Distance and route</li>
        <li>Seasonal demand and market fluctuations</li>
        <li>Expedited or special handling requests</li>
      </ul>
      <p>
        Quotes are valid for seven (7) days unless otherwise noted. Final prices are confirmed once the deposit is
        received and booking is finalized.
      </p>

      <h2>5. Booking and Payment</h2>
      <p>
        To secure transport, customers must provide accurate details and pay a non-refundable deposit. Remaining
        balances are due as outlined in the order confirmation and are typically paid directly to the carrier upon
        delivery. We accept major credit/debit cards and electronic transfers.
      </p>

      <h2>6. Vehicle Condition and Inspection</h2>
      <p>Before shipment, customers must ensure the following:</p>
      <ul>
        <li>The vehicle is operable with functional brakes.</li>
        <li>All personal belongings are removed (not covered by insurance).</li>
        <li>The fuel tank contains no more than one-quarter (¼) of a tank.</li>
        <li>All alarms and toll tags are disabled.</li>
        <li>Existing vehicle damage is documented prior to pickup.</li>
      </ul>
      <p>
        At pickup and delivery, the customer (or authorized representative) must inspect and sign the Bill of Lading,
        verifying vehicle condition.
      </p>

      <h2>7. Scheduling and Delivery</h2>
      <p>
        Pickup and delivery timelines are estimates and may vary due to weather, traffic, mechanical issues, or
        unforeseen delays. While <strong>Nest Auto Transport</strong> strives to meet estimated dates, we are not
        liable for delays or related consequential damages.
      </p>

      <h2>8. Cancellation and Refund Policy</h2>
      <p>Our cancellation policy is as follows:</p>
      <ul>
        <li>
          Cancellations made before carrier assignment may qualify for a partial refund, minus a service fee.
        </li>
        <li>
          Cancellations made after carrier assignment but before pickup will result in forfeiture of the deposit.
        </li>
        <li>
          Cancellations after carrier arrival may incur additional charges.
        </li>
      </ul>
      <p>
        Refund eligibility and amounts will be clearly outlined in your booking confirmation or service agreement.
      </p>

      <h2>9. Insurance and Liability</h2>
      <p>
        All partner carriers are required to maintain active cargo insurance compliant with federal transportation
        laws. Coverage applies to damages sustained during transit, subject to carrier policy terms. To file a claim:
      </p>
      <ul>
        <li>All damages must be noted on the Bill of Lading at delivery.</li>
        <li>Claims not documented at delivery may be denied.</li>
        <li>Notify <strong>Nest Auto Transport</strong> within 24 hours of delivery to begin the claims process.</li>
      </ul>
      <p>Insurance does not cover:</p>
      <ul>
        <li>Pre-existing damage</li>
        <li>Personal belongings in the vehicle</li>
        <li>Mechanical or electrical failures unrelated to transport</li>
        <li>Natural disasters or "acts of God"</li>
      </ul>

      <h2>10. Intellectual Property</h2>
      <p>
        All website content, including text, graphics, logos, and design, is the property of
        <strong>Nest Auto Transport</strong> and is protected under U.S. copyright law. Unauthorized use or
        reproduction is strictly prohibited.
      </p>

      <h2>11. Limitation of Liability</h2>
      <p>
        <strong>Nest Auto Transport's</strong> total liability shall not exceed the amount paid for brokerage
        services. We are not liable for indirect, incidental, or consequential damages, including:
      </p>
      <ul>
        <li>Transit delays</li>
        <li>Acts or omissions of carriers</li>
        <li>Lost profits or business opportunities</li>
        <li>Undocumented damages</li>
      </ul>

      <h2>12. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless <strong>Nest Auto Transport</strong>, its employees, affiliates, and
        partners from any claims, damages, or expenses arising from your use of our Services or violation of these
        Terms.
      </p>

      <h2>13. Governing Law and Dispute Resolution</h2>
      <p>
        These Terms are governed by the laws of the State of Virginia. Any dispute arising under or related to these
        Terms shall be resolved exclusively through binding arbitration in Virginia, under the rules of the American
        Arbitration Association.
      </p>

      <h2>14. Amendments</h2>
      <p>
        <strong>Nest Auto Transport</strong> reserves the right to modify or update these Terms at any time. Changes
        will be posted on our website with an updated "Last Revised" date. Continued use of our Services constitutes
        acceptance of the revised Terms.
      </p>

      <h2>15. Contact Information</h2>
      <p>
        For any questions regarding these Terms, please contact us:
      </p>
      <p>
        <strong>Email:</strong> info@nestautotransport.com<br />
        <strong>Phone:</strong> +1 (888) 512-NEST<br />
        <strong>Address:</strong> Nest Auto Transport Inc. 13151 Emil Rd Suite # 210-D Dallas TX 75240
      </p>
    </PolicyLayout>
  );
};

export default TermsConditions;


